<template>
  <basic-container>
    <el-dialog
      title="选择收费项"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="64%"
      :show-close="false"
      @closed="handleClose"
      append-to-body
    >
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :permission="permissionList"
        :before-open="beforeOpen"
        v-model="form"
        ref="crud"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot="num" slot-scope="scope">
          <el-input v-model="scope.row.num" :disabled="scope.row.disabled"></el-input>
        </template>
      </avue-crud>
      <el-row>
        <el-tag
          style="margin-right: 10px;"
          v-for="(item, i) in costPrice"
          :key="item[id]"
          closable
          @close="handleCloseCostPrice(item, i)"
        >
          费用名称:{{ item.costName }},数量:{{ item.num + item.$unit }},金额:{{
            Number(item.num) * Number(item.price)
          }}元
        </el-tag>
        <el-button type="primary" @click="dataToParent">确 认</el-button>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/repaircostprice/repaircostprice';
import { mapGetters } from 'vuex';

var V = (rule, value, callback) => {
  if (value > 10000) {
    callback(new Error('请不要输入错误的价格'));
  } else if (value < 0) {
    callback(new Error('请不要输入错误的价格'));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      costPrice: [],
      openFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        selection: false,
        indexLabel: '序号',
        labelWidth: 130,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        refreshBtn: false,
        columnBtn: false,
        cellBtn: true,
        cancelBtn: false,
        editBtnText: '选择数量',
        column: [
          {
            label: '费用类型',
            prop: 'costType',

            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=cost_type',
            props: { label: 'dictValue', value: 'dictKey' },
            filter: true,
            filterMethod: function (value, row, column) {
              return row.costType === value;
            },
          },
          {
            label: '费用名称',
            prop: 'costName',

            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '计量单位',
            prop: 'unit',

            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=unit',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '价格(元)',
            prop: 'price',
            dataType: 'number',
          },
          {
            label: '材质',
            prop: 'materials',
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '型号',
            prop: 'materialType',
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '品牌',
            prop: 'brand',
            maxlength: 15,
            showWordLimit: true,
          },
          {
            label: '数量',
            prop: 'num',
            cell: true,
            type: 'input',
            rules: [
              {
                required: true,
                message: '请输入数量',
                trigger: 'change',
              },
              { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
            ],
            maxlength: 2,
            showWordLimit: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repaircostprice_add, false),
        viewBtn: this.vaildData(this.permission.repaircostprice_view, false),
        delBtn: this.vaildData(this.permission.repaircostprice_delete, false),
        editBtn: this.vaildData(this.permission.repaircostprice_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {},
  methods: {
    dataToParent() {
      this.$emit('getData', this.costPrice);
      this.openFlag = false;
    },
    handleCloseCostPrice(row, index) {
      this.costPrice = this.costPrice.filter((v, i, a) => {
        if (index === i) {
          return false;
        } else {
          return true;
        }
      });
    },
    handleClose() {
      this.data = [];
      this.query = {};
      this.page = {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      };
    },
    openRepairCostPriceDialog(data) {
      this.onLoad();
      this.openFlag = true;
      this.costPrice = data;
    },
    rowSave(row, loading, done) {
      if (!row.areaId) {
        row.areaId = 0;
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      row.totalAmount = Number(row.num) * Number(row.price);
      this.costPrice.push(row);
      loading();
      done();
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
